module.exports = __webpack_public_path__ + "static/media/achieve4.e4d239ec.png";